// test797
(797 && 0);
